import * as React from 'react'
import { useState } from 'react'
import {ALERTS} from "../../@common/constants";

const Context = React.createContext({})

export function AlertsContextProvider({ children }) {

	const [state, setState] = useState({
		showAlertsDrawer: false, alertsNotifications: null, totalAlertsNotifications: null, alerts: [], 
		isLoadingAlerts: false, isLoadingTable: true, ikeys: [], checkElements: [], cols: [], 
		showNotificationsDrawer: false, dataRow: null, openNotifications: false, alertsOccupancy: null,
        selectedAlert: ALERTS.TYPE.COMPETITION,
	})

	return <Context.Provider value={{ state, setState }}>
		{children}
	</Context.Provider>
}

export default Context